import { useEffect } from 'react';

export const useLayoutProps = (props, setLayoutProps) => {
    useEffect(() => {
        if (setLayoutProps) {
            setLayoutProps(props);
            return () => setLayoutProps({});
        }
    }, [props, setLayoutProps]);
    return;
};
